export const FEATURE_NAMESPACE = 'feature.reliability-engineer-dashboard'
